import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";

export const useShouldShowVerticalImages = () => {
  const categoryModel = useCurrentCategoryModel();
  const { mostSpecificPathIdentifier } = categoryModel ?? {};
  const { shouldShowVerticalTile } = useCategoryStore();
  return shouldShowVerticalTile(mostSpecificPathIdentifier);
};
